import "./index.scss";
import React from "react";

export const LoadingSpinner: React.FC = () => {
    return <div data-testid="spinner" className="loader"/>
}